const fields = [
  {
    key: 'date',
    label: 'global.field.date',
    header: 'date',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'day',
    label: 'global.time.days',
    header: 'day',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
    disabled: false,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'hullNo',
    label: 'report.fields.hullNo',
    header: 'hullNo',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'engineOnDuration',
    label: 'report.fields.engineOnDuration',
    header: 'engineOnDuration',
    filter: false,
    width: 20,
    disabled: false,
  },
  {
    key: 'ptoDuration',
    label: 'report.fields.ptoDuration',
    header: 'ptoDuration',
    filter: false,
    width: 20,
    disabled: false,
  }
]
export default fields
